function PageNotFound(){
    return(
        <h1>Ops... Denne siden finnes ikke</h1>
    );
}
export default PageNotFound;